import { create } from "zustand";

interface WithdrawModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useWithdrawModalStore = create<WithdrawModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
